<template>
  <div v-show="state" class="dialog_wrapper" style="z-index: 2003;">
    <div class="dialog">
      <div class="dialog_header">
        <button type="button" class="dialog__headerbtn" @click="close">
          <i class="iconfont iconquxiao1"></i>
        </button>
      </div>
      <div class="dialog_body">
        <img src="../../static/images/bg4.png" alt />
      </div>
      <div class="dialog_footer">如果您有医生资料线索想要补充，请扫描二维码。</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DialogShare",
  props: ["state"],
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit("transfer", this.state);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.dialog_wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  background: rgba(0, 0, 0, 0.5);
  .dialog {
    position: relative;
    margin: 0 auto 50px;
    margin-top: 10vh;
    background-color: #C7DEE6;
    box-sizing: border-box;
    width: 80%;
    border-radius: 6px;
    .dialog_header {
      display: flex;
      justify-content: flex-end;
      padding: 8px 8px 0;
      .dialog__headerbtn {
        width: 26px;
        height: 26px;
        padding: 0;
        background: #fff;
        border-radius: 50%;
        border: none;
        outline: none;
        cursor: pointer;
        i {
          font-size: 10px;
        }
      }
    }
  }
  .dialog_body {
    padding: 0 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    .bg_img {
      width: 180px;
      height: 190px;
      background: #fff;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .dialog_footer {
    padding: 14px 0;
    font-size: 12px;
    letter-spacing: 0px;
    color: #333333;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dialogShare.vue